export const authors = [
    {
        name: "Jaeyoon Song",
        affiliation: "MIT",
        website: "https://jaeyoon.io",
        image: "/authors/jaeyoon.jpeg",
    },
    {
        name: "Zahra Ashktorab",
        affiliation: "IBM Research",
        website: "http://zahraashktorab.com",
        image: "/authors/zahra.png",
    },
    {
        name: "Thomas W. Malone",
        affiliation: "MIT",
        website: "https://mitsloan.mit.edu/faculty/directory/thomas-w-malone",
        image: "/authors/tom.jpg",
    },
    {
        name: "Abdullah Almaatouq",
        affiliation: "MIT",
        website:
            "https://mitsloan.mit.edu/faculty/directory/abdullah-almaatouq",
        image: "/authors/abdullah.jpg",
    },
    {
        name: "Michiel A. Bakker",
        affiliation: "MIT & Google DeepMind",
        website: "https://miba.dev/",
        image: "/authors/michiel.jpg",
    },
    {
        name: "Dan Goldstein",
        affiliation: "Microsoft Research",
        website: "https://www.dangoldstein.com/",
        image: "/authors/dan.jpg",
    },
    {
        name: "Benjamin Lira Luttges",
        affiliation: "University of Pennsylvania",
        website: "https://lirabenjamin.github.io/",
        image: "/authors/ben.jpeg",
    },
    {
        name: "Mohammed Alsobay",
        affiliation: "Microsoft Research",
        website: "https://malsobay.com/",
        image: "/authors/mohammed.jpg",
    },
    {
        name: "Juho Kim",
        affiliation: "KAIST",
        website: "https://juhokim.com/",
        image: "/authors/juho.jpg",
    },
    {
        name: "Dokyun Lee",
        affiliation: "Boston University",
        website: "https://www.bu.edu/questrom/profiles/dokyun-dk-lee/",
        image: "/authors/dk.jpg",
    },
    {
        name: "David Karger",
        affiliation: "MIT",
        website: "https://people.csail.mit.edu/karger/",
        image: "/authors/david.jpg",
    },
    {
        name: "Christoph Riedl",
        affiliation: "Northeastern University",
        website:
            "https://damore-mckim.northeastern.edu/people/christoph-riedl/",
        image: "/authors/chris.png",
    },
    {
        name: "Michelle Vaccaro",
        affiliation: "MIT",
        website: "https://trancik.mit.edu/michelle-vaccaro/",
        image: "/authors/michelle.jpeg",
    },
    {
        name: "Andres Campero",
        affiliation: "MIT",
        website: "https://andrescampero.mit.edu/",
        image: "/authors/andres.jpg",
    },
    {
        name: "Jennifer Heyman",
        affiliation: "MIT",
        website: "https://www.linkedin.com/in/jennifer-heyman/",
        image: "/authors/jenny.jpeg",
    },
    {
        name: "Werner Geyer",
        affiliation: "IBM Research",
        website: "https://wernergeyer.com/",
        image: "/authors/werner.jpeg",
    },
    {
        name: "Casey Dugan",
        affiliation: "IBM Research",
        website: "https://www.linkedin.com/in/casey-dugan1/",
        image: "/authors/casey.jpeg",
    },
    {
        name: "Qian Pan",
        affiliation: "IBM Research",
        website: "https://research.ibm.com/people/qian-pan",
        image: "/authors/qian.jpeg",
    },
    {
        name: "Soya Park",
        affiliation: "Emory University",
        website: "https://people.csail.mit.edu/soya/",
        image: "/authors/soya.jpeg",
    },
    {
        name: "Eunyoung Ko",
        affiliation: "KAIST",
        website: "https://eunyoungko.com/",
        image: "/authors/eunyoung.jpeg",
    },
    {
        name: "Jihee Kim",
        affiliation: "KAIST",
        website: "http://www.jiheekim.net/",
        image: "/authors/jihee.jpeg",
    },
    {
        name: "Sungchul Lee",
        affiliation: "KAIST",
        image: "/authors/sungchul.png",
    },
    {
        name: "Donghoon Shin",
        affiliation: "University of Washington",
        // website: "https://donghoon.io/",
        // image: "/authors/donghoon.png",
    },
    {
        name: "Seokwoo Song",
        affiliation: "Samsung Research",
        image: "/authors/seokwoo.jpg",
    },
    {
        name: "Jisoo Park",
        affiliation: "SK Broadband",
    },
    {
        name: "Joonhwan Lee",
        affiliation: "Seoul National University",
        website: "https://scholar.google.com/citations?user=SXVo9qkAAAAJ&hl=en",
        image: "/authors/joonhwan.jpg",
    },
    {
        name: "Soojin Jun",
        affiliation: "Yonsei University",
        website:
            "https://uic.yonsei.ac.kr/main/academic.asp?mid=m03_01_01&act=view&uid=947",
        image: "/authors/soojin.jpg",
    },
    {
        name: "Changhee Kim",
        affiliation: "Incheon National University",
        image: "/authors/changhee.png",
    },
    {
        name: "Kiroong Choe",
        affiliation: "Seoul National University",
        website: "https://kiroong.github.io/",
        image: "/authors/kiroong.png",
    },
    {
        name: "Jaemin Jo",
        affiliation: "Sungkyunkwan University",
        website: "https://www.jaeminjo.com/",
        image: "/authors/jaemin.jpeg",
    },
    {
        name: "Jinwook Seo",
        affiliation: "Seoul National University",
        website: "http://hcil.snu.ac.kr/people/jinwook-seo",
        image: "/authors/jinwook.png",
    },
    {
        name: "Arman Vossoughi",
        affiliation: "Boston University",
        website: "https://www.linkedin.com/in/armanvoss/",
        image: "/authors/arman.jpeg",
    },
    {
        name: "Hongzun Zhang",
        affiliation: "Boston University",
        website: "https://www.linkedin.com/in/hongzun-zhang/",
        image: "/authors/hongzun.jpeg",
    },
    {
        name: "Alice Cai",
        affiliation: "MIT",
        website: "https://mitsloan.mit.edu/programs/phd/alice-cai",
        image: "/authors/alice.jpeg",
    },
    {
        name: "Haoran Wen",
        affiliation: "MIT",
        image: "/authors/haoran.jpeg",
    },
];
